export const MIN_AMOUNT_ALLOWED_FOR_REDEMPTION = 1000; // 10 * 100;
export const WEEKLY_PAY_OUT = "2023-11-10T18:00:00.000Z";
export const WEEKLY_REDEEM = "2023-11-09T18:00:00.000Z";
